/*
 * File: resource.slice.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 2, 2025 at 9:17 AM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 10, 2025 at 11:31 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import { createSlice } from '@reduxjs/toolkit';

// Constants
import { FEED_ACTION_RECOMMENDED } from '../../../../constants/feed.constants';


/**
 * Constants
 */

export const initialState = {
	feedStatus: 'idle',
	featuredStatus: 'idle',
	items: [],
	featuredItems: [],
	actionSortBy: FEED_ACTION_RECOMMENDED,
	error: null,
};


/**
 * Slices
 */

export const resourceSlice = createSlice({
	name: 'resource',
	initialState,
	reducers: {
		updateResources: (state, action) => {

			// Set state
			state.items = action.payload;
			state.feedStatus = 'final';
		},
		updateFeaturedResources: (state, action) => {

			// Set state
			state.featuredItems = action.payload;
			state.featuredStatus = 'final';
		},
		updateActionSortBy: (state, action) => {

			// Set state
			state.actionSortBy = action.payload;
		},
		clearResources: (state) => {

			// Clear state
			state.items = [];
			state.feedStatus = 'idle';
		},
		clearFeaturedResources: (state) => {

			// Clear state
			state.featuredItems = [];
			state.featuredStatus = 'idle';
		}
	},
	extraReducers: {},
});


/**
 * Exports
 */

export const {
	updateResources, updateFeaturedResources, updateActionSortBy, clearResources, clearFeaturedResources
} = resourceSlice.actions;

export default resourceSlice.reducer;
